import { versionState } from "@accessinformatica/service-worker";
import { combineReducers } from "redux";
import { LOGIN, LOGOUT } from "../actions/auth";
import afiliaciones from "./afiliaciones";
import auth from "./auth";
import certificadoCobertura from "./certificadoCobertura";
import contrato from "./contrato";
import cuentaCorriente from "./cuentaCorriente";
import denuncia from "./denuncia";
import dependenciaEmpleador from "./dependenciaEmpleador";
import dinerarias from "./dinerarias";
import direccion from "./direccion";
import empleador from "./empleador";
import error from "./error";
import establecimiento from "./establecimiento";
import examenesPeriodicos from "./examenesPeriodicos";
import informacion from "./informacion";
import logo from "./logo";
import nomina from "./nomina";
import notificacion from "./notificacion";
import nte from "./nte";
import obra from "./obra";
import reintegros from "./reintegros";
import resolucion from "./resolucion";
import rgrl from "./rgrl";
import siniestralidad from "./siniestralidad";
import userPreferences from "./userPreferences";
import warning from "./warning";
const allReducers = combineReducers({
  auth,
  error,
  userPreferences,
  warning,
  informacion,
  contrato,
  cuentaCorriente,
  denuncia,
  dinerarias,
  direccion,
  nomina,
  certificadoCobertura,
  siniestralidad,
  notificacion,
  reintegros,
  rgrl,
  establecimiento,
  nte,
  logo,
  examenesPeriodicos,
  resolucion,
  obra,
  empleador,
  afiliaciones,
  dependenciaEmpleador,
  versionState,
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT || (action.type === `${LOGIN}_FULFILLED` && action?.meta?.asEmpleador)) {
    return allReducers({ auth: { ...state.auth, data: {} }, logo: state.logo, versionState: state.versionState }, action);
  }
  return allReducers(state, action);
};

export default rootReducer;
